import { ADD_UPDATE_DIAGRAM_TEMPLATE_SUCCESS, ADD_UPDATE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_ERROR, ADD_UPDATE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_SUCCESS, DELETE_DIAGRAM_TEMPLATE_SUCCESS, DELETE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_ERROR, DELETE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_SUCCESS, FETCH_DIAGRAM_TEMPLATES_ERROR, FETCH_DIAGRAM_TEMPLATES_START, FETCH_DIAGRAM_TEMPLATES_SUCCESS, FETCH_GROUP_DIAGRAM_TEMPLATES_ERROR, FETCH_GROUP_DIAGRAM_TEMPLATES_SUCCESS, FETCH_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATES_ERROR, FETCH_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATES_START, FETCH_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATES_SUCCESS, RESET_DIAGRAM_TEMPLATES } from '../actions/DiagramTemplatesActions';
import _ from 'lodash';

const INIT_STATE = {
    loading: false,
    showMessage: false,
    diagramTemplates: [],
    publicCategorizedDiagramTemplates: [],
    groupDiagramTemplates: null
}

export default (state = INIT_STATE, action) => {
    let newState;
    let newPublicCategorizedDiagramTemplates;
    let firstNode;
    let secondNode;
    let index;

    switch (action.type) {

        case FETCH_DIAGRAM_TEMPLATES_START:
        case FETCH_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATES_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_DIAGRAM_TEMPLATES_SUCCESS: {
            return {
                ...state,
                loading: false,
                diagramTemplates: _.cloneDeep(action.diagramTemplates)
            }
        }
        case FETCH_DIAGRAM_TEMPLATES_ERROR:
        case RESET_DIAGRAM_TEMPLATES: {
            return { ...state, error: '', message: '', loading: false, diagramTemplates: [] };
        }


        case DELETE_DIAGRAM_TEMPLATE_SUCCESS: {
            newState = _.cloneDeep(state);
            newState.diagramTemplates = newState.diagramTemplates.filter(diagramTemplate => diagramTemplate.diagramTemplateId !== action.diagramTemplateId)
            return { ...newState }
        }

        case ADD_UPDATE_DIAGRAM_TEMPLATE_SUCCESS: {
            newState = _.cloneDeep(state);
            index = newState.diagramTemplates.findIndex(diagramTemplate => diagramTemplate.diagramTemplateId === action.diagramTemplate.diagramTemplateId);
            if (index > -1) {
                newState.diagramTemplates[index] = action.diagramTemplate;
            } else {
                newState.diagramTemplates.push(action.diagramTemplate)
            }
            return { ...newState }
        }

        case FETCH_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATES_SUCCESS: {
            return { ...state, loading: false, publicCategorizedDiagramTemplates: action.publicCategorizedDiagramTemplates };
        }
        case FETCH_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATES_ERROR: {
            return { ...state, loading: false, error: action.error };
        }
        case ADD_UPDATE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_SUCCESS: {
            newPublicCategorizedDiagramTemplates = { ...state.publicCategorizedDiagramTemplates };
            firstNode = { ...newPublicCategorizedDiagramTemplates[action.template.directory1] };
            if (Object.keys(firstNode).length === 0) {
                firstNode[action.template.directory2] = [{ ...action.template }];
                newPublicCategorizedDiagramTemplates[action.template.directory1] = { ...firstNode };
            } else {
                secondNode = firstNode[action.template.directory2] ? [...firstNode[action.template.directory2]] : [];
                if (secondNode.length === 0) {
                    firstNode[action.template.directory2] = [{ ...action.template }];
                    newPublicCategorizedDiagramTemplates[action.template.directory1] = { ...firstNode };
                } else {
                    index = secondNode.findIndex(node => node.diagramTemplateId === action.template.diagramTemplateId && node.name === action.template.name);
                    if (index > -1) {
                        secondNode.splice(index, 1, action.template);
                    } else {
                        secondNode.push(action.template);
                    }
                    firstNode[action.template.directory2] = [...secondNode];
                    newPublicCategorizedDiagramTemplates[action.template.directory1] = { ...firstNode };
                }
            }
            return { ...state, loading: false, submitting: false, showModal: false, publicCategorizedDiagramTemplates: { ...newPublicCategorizedDiagramTemplates } };
        }
        case ADD_UPDATE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_ERROR: {
            return { ...state, loading: false, submitting: false };
        }

        case DELETE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_SUCCESS: {
            newPublicCategorizedDiagramTemplates = { ...state.publicCategorizedDiagramTemplates };
            firstNode = { ...newPublicCategorizedDiagramTemplates[action.template.directory1] };
            if (Object.keys(firstNode).length > 0) {
                secondNode = firstNode[action.template.directory2] ? [...firstNode[action.template.directory2]] : [];
                if (secondNode.length > 0) {
                    index = secondNode.findIndex(node => node.diagramTemplateId === action.template.diagramTemplateId && node.name === action.template.name);

                    if (index > -1) {
                        secondNode.splice(index, 1);
                        firstNode[action.template.directory2] = [...secondNode];
                        newPublicCategorizedDiagramTemplates[action.template.directory1] = { ...firstNode };
                    }
                }
            }
            return { ...state, loading: false, submitting: false, publicCategorizedDiagramTemplates: { ...newPublicCategorizedDiagramTemplates } };
        }
        case DELETE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_ERROR: {
            return { ...state, loading: false, submitting: false };
        }

        case FETCH_GROUP_DIAGRAM_TEMPLATES_SUCCESS: {
            return { ...state, loading: false, groupDiagramTemplates: _.cloneDeep(action.groupDiagramTemplates) };
        }

        case FETCH_GROUP_DIAGRAM_TEMPLATES_ERROR: {
            return { ...state, loading: false, groupDiagramTemplates: null };
        }


        default:
            return state;
    }
}
